import React, { useState } from 'react'

import { RadioGroup } from '@headlessui/react'

import { iRadioOptions } from 'interfaces/iRadioOptions'

import { RadioCircle } from './RadioCircle/RadioCircle'

export interface RadioButtonProps {
  /**
   * Radio group label
   */
  label?: string
  /**
   * Options to be displayed
   */
  options: iRadioOptions[]
}

export const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  (props, ref) => {
    const { label, options } = props
    const [selectedOpt, setSelectedOpt] = useState(
      options?.find((opt) => opt.defaultChecked).value || ''
    )
    return (
      <RadioGroup ref={ref} value={selectedOpt} onChange={setSelectedOpt}>
        {label && <RadioGroup.Label>{label}</RadioGroup.Label>}
        {options &&
          options.map((opt) => (
            <RadioGroup.Option
              key={opt.value.toString()}
              id={opt.value.toString()}
              value={opt.value}
              disabled={!!opt.disabled}
            >
              {({ checked }) => (
                <>
                  <RadioCircle isChecked={checked} isDisabled={opt.disabled} />
                  <span className="ml-2">{opt.text}</span>
                </>
              )}
            </RadioGroup.Option>
          ))}
      </RadioGroup>
    )
  }
)
